import { Controller } from 'stimulus';
import formatPrice from '@/helpers/formatPrice';

class CartSummaryController extends Controller {
  onPaymentTypeChange({ target }) {
    const { price } = target.dataset;

    if (typeof price === 'undefined') {
      return;
    }

    this.totalTarget.innerHTML = formatPrice(price);
  }
}

CartSummaryController.targets = [
  'total',
];

export default CartSummaryController;
